/**
 * The single "is this person VidMax staff?" rule — backend tRPC gate, backend `isAdminUser`, and
 * the web sidebar all import this. Staff = `internalMisc.isSuper` OR a staff-domain email.
 */
const STAFF_EMAIL_DOMAINS = ["@aixlabs.co", "@vidmax.ai"]

/**
 * Staff-domain accounts that must stay plain customers, even with `isSuper` set. Browser E2E signs
 * in with a shared password (no MFA) — that login must never carry admin rights. One per env: the
 * E2E guard refuses a prod account that reuses the dev email.
 */
export const NON_STAFF_TEST_EMAILS: readonly string[] = [
  "integrationtest+customer@aixlabs.co",
  "integrationtest+customer-dev@aixlabs.co",
]

interface IStaffCandidate {
  email?: string | null
  internalMisc?: { isSuper?: boolean | null } | null
}

const isNonStaffTestEmail = (email: string): boolean => NON_STAFF_TEST_EMAILS.includes(email)

export const isStaffEmail = (email?: string | null): boolean => {
  const normalized = email?.toLowerCase() ?? ""
  if (isNonStaffTestEmail(normalized)) return false
  return STAFF_EMAIL_DOMAINS.some((domain) => normalized.endsWith(domain))
}

export const isStaffUser = (user?: IStaffCandidate | null): boolean => {
  if (isNonStaffTestEmail(user?.email?.toLowerCase() ?? "")) return false
  return user?.internalMisc?.isSuper === true || isStaffEmail(user?.email)
}
